// extracted by mini-css-extract-plugin
export default {"variablesSelector":"VariablesSelector_variablesSelector__3lSS1"};